export const formFields = Object.freeze({
  POSITION: 'position',
  COMPANY_STAGE: 'company-stage',
  EMPLOYMENT_TYPES: 'employment-types',
  DEALS_BREAKERS: 'deals-breakers',
  LOCATION: 'location',
  RELOCATION: 'relocation',
  JOB_DESCRIPTION: 'job-description',
});
